import callApi from "../libs/helpers/callApi";

import { getBrandDetailApi } from "../api/brand.api";

export const BRAND_DETAIL_LOADING = "BRAND_DETAIL_LOADING";
export const BRAND_DETAIL_LOADED = "BRAND_DETAIL_LOADED";
export const BRAND_DETAIL_LOAD_ERROR = "BRAND_DETAIL_LOAD_ERROR";

export const getBrandDetailAction = callApi({
  apiCall: (p) => getBrandDetailApi(p),
  secured: true,
  startAction: BRAND_DETAIL_LOADING,
  successAction: BRAND_DETAIL_LOADED,
  errorAction: BRAND_DETAIL_LOAD_ERROR,
});
